export enum PaymentSystem {
  WebMoney,
  Capitalist,
  USDT_ERC20,
  USDT_TRC20,
  USDT_OMNI,
  CreditCard,
}
